import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import Pill from 'LuxKit/Pill'
import { useAppSelector } from 'hooks/reduxHooks'
import { isPropertyCollectEnabled } from 'selectors/offerSelectors'

const WrappingPill = styled(Pill)`
  height: auto;
  min-height: var(--pill-height);
  max-width: 100%;
  min-width: 0;
  align-items: center;
  flex-wrap: nowrap;
  white-space: normal;

  > :not(svg) {
    min-width: 0;
  }
`

interface Props {
  doNotShowOnSearchPage?: boolean
  hasMultipleOptions?: boolean
  wrap?: boolean
}

function PayAtPropertyPill({ hasMultipleOptions = true, doNotShowOnSearchPage = false, wrap = false }: Props) {
  const intl = useIntl()
  const isFeatureEnabled = useAppSelector(isPropertyCollectEnabled)

  if (doNotShowOnSearchPage) {
    return null
  }

  if (!isFeatureEnabled) {
    return null
  }

  const payAtPropertyAvailableLabel = intl.formatMessage({
    id: 'NCYkcQMU8Vp03pyyZzyc',
    defaultMessage: 'Pay at property available',
  })

  const payAtPropertyLabel = intl.formatMessage({
    id: 'e0ogjGxyCSqJ0OCSOwtO',
    defaultMessage: 'Pay at property',
  })

  const Component = wrap ? WrappingPill : Pill

  return (
    <Component data-testid="pay-at-property-pill" startIcon={<LineClockDollarIcon />}>
      {hasMultipleOptions ? payAtPropertyAvailableLabel : payAtPropertyLabel}
    </Component>
  )
}

export default PayAtPropertyPill
